export default "__VITE_ASSET__eea06886__"